import axios from "axios";
import { getSessionId } from "../../../../../utils/tokenHandlers";

export const getIECDetails = (value: string) => {
  const sessionid = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/iecdetailed`,
      {
        params: {
          iec: value,
          consent: "Y",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((resp) => resp)
    .catch((err) => err);
};
